import React from 'react';
import { Link } from 'react-router-dom';

const PricingTeaser = () => {
  return (
    <section className="section bg-primary">
      <div className="container">
        <div className="text-center" style={{ maxWidth: '640px', margin: '0 auto 48px' }}>
          <span className="section-kicker" style={{ color: '#e0b04c', justifyContent: 'center' }}>
            Abonnements
          </span>
          <h2 className="section-title">Choisissez la formule adaptée à vos besoins</h2>
          <p style={{ color: 'rgba(255,255,255,0.8)' }}>
            Créez votre compte gratuitement, puis passez à une formule Classique ou Premium
            pour un accès complet à l'ensemble de nos publications.
          </p>
        </div>

        <div className="grid grid-3" style={{ maxWidth: '960px', margin: '0 auto' }}>
          <div className="price-card" style={{ background: 'rgba(255,255,255,0.06)', borderColor: 'rgba(255,255,255,0.15)', color: '#fff' }}>
            <span className="price-name" style={{ color: 'rgba(255,255,255,0.7)' }}>Gratuit</span>
            <div className="price-amount" style={{ color: '#fff' }}>
              0 <span style={{ color: 'rgba(255,255,255,0.6)' }}>/ mois</span>
            </div>
            <p style={{ color: 'rgba(255,255,255,0.75)', fontSize: '0.9rem' }}>
              Accès aux résumés et aux publications en libre accès.
            </p>
          </div>

          <div className="price-card featured" style={{ background: 'rgba(255,255,255,0.1)', borderColor: '#e0b04c', color: '#fff' }}>
            <span className="price-badge">Populaire</span>
            <span className="price-name" style={{ color: 'rgba(255,255,255,0.7)' }}>Classique</span>
            <div className="price-amount" style={{ color: '#fff' }}>
              15 000 <span style={{ color: 'rgba(255,255,255,0.6)' }}>FCFA / mois</span>
            </div>
            <p style={{ color: 'rgba(255,255,255,0.75)', fontSize: '0.9rem' }}>
              Accès complet aux rapports et études classiques.
            </p>
          </div>

          <div className="price-card" style={{ background: 'rgba(255,255,255,0.06)', borderColor: 'rgba(255,255,255,0.15)', color: '#fff' }}>
            <span className="price-name" style={{ color: 'rgba(255,255,255,0.7)' }}>Premium</span>
            <div className="price-amount" style={{ color: '#fff' }}>
              35 000 <span style={{ color: 'rgba(255,255,255,0.6)' }}>FCFA / mois</span>
            </div>
            <p style={{ color: 'rgba(255,255,255,0.75)', fontSize: '0.9rem' }}>
              Accès intégral à toutes les publications, sans restriction.
            </p>
          </div>
        </div>

        <div className="text-center" style={{ marginTop: '36px' }}>
          <Link to="/abonnements" className="btn btn-primary">
            Comparer les formules en détail
          </Link>
        </div>
      </div>
    </section>
  );
};

export default PricingTeaser;